module.exports = __webpack_public_path__ + "static/media/belcolor__11.22140500.jpg";